import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2025 Designed & Built by <a href="https://github.com/SelinCifcii" target="_blank" rel="noopener noreferrer" className="footer-link">Selin Çifci</a></p>
      </div>
    </footer>
  );
};

export default Footer; 